import React from 'react';
import { Builder } from '@builder.io/react';

interface TypeformEmbedProps {
  formUrl: string;
  height?: number;
}

const TypeformEmbed: React.FC<TypeformEmbedProps> = ({ formUrl, height = 500 }) => {
  if (!formUrl) return null;

  return (
    <div style={{ width: '100%', height }}>
      <iframe
        src={formUrl}
        width='100%'
        height='100%'
        frameBorder='0'
        style={{ border: 'none' }}
        allow='camera; microphone; autoplay; encrypted-media;'
        title='Typeform Embed'
      ></iframe>
    </div>
  );
};

export default TypeformEmbed;
